import { render, staticRenderFns } from "./DesignPortfolioView.vue?vue&type=template&id=6c518598&scoped=true&"
import script from "./DesignPortfolioView.vue?vue&type=script&lang=js&"
export * from "./DesignPortfolioView.vue?vue&type=script&lang=js&"
import style0 from "./DesignPortfolioView.vue?vue&type=style&index=0&id=6c518598&prod&scoped=true&lang=css&"
import style1 from "./DesignPortfolioView.vue?vue&type=style&index=1&id=6c518598&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c518598",
  null
  
)

export default component.exports